import { dicomEditJobQueryKey, markDicomEditSubmitted } from '@/hooks/use-dicom-edit-job';
import { getStudyDicomTags, submitDicomEdits } from '@/lib/api';
import { invalidateStudyContent } from '@/lib/viewer/studyContentQueries';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
const studyDicomTagsQueryKey = (studyId, focusSopInstanceUid) => ['study-dicom-tags', studyId, focusSopInstanceUid ?? null];
/**
 * The study's editable DICOM tags as its files hold them. Read fresh every time the editor
 * opens (the files may have been edited since), and never retried on a 4xx: a 403 or a 404
 * is an answer, not a hiccup.
 */
export function useStudyDicomTags(studyId, focusSopInstanceUid, enabled) {
    return useQuery({
        queryKey: studyDicomTagsQueryKey(studyId, focusSopInstanceUid),
        queryFn: () => getStudyDicomTags(studyId, focusSopInstanceUid),
        enabled,
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: false,
        retry: false,
    });
}
/**
 * Sends the edits. On success the worklist copies have already changed server-side, so the
 * worklist and the study's own queries refresh, and the job query starts polling the rewrite.
 */
export function useSubmitDicomEdits(studyId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => submitDicomEdits(studyId, body),
        onSuccess: (result) => {
            markDicomEditSubmitted(result.jobId);
            void queryClient.invalidateQueries({ queryKey: dicomEditJobQueryKey(studyId) });
            void queryClient.invalidateQueries({ queryKey: ['studies'] });
            void invalidateStudyContent(queryClient, studyId);
        },
    });
}
